<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>生产管理</el-breadcrumb-item>
      <el-breadcrumb-item>生产详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <el-page-header @back="$router.go(-1)" content="生产详情">
      </el-page-header>
      <div class="panel-body">
        <div>
          <div>产品编号： <DrillLink :no="product.identifier"></DrillLink></div>
          <p v-if="product.status == 0">生产状态： 待生产</p>
        </div>

        <div class="flow-info" v-if="flow.id > 0">
          <div>
            流程任务名：
            <span>{{ flow.name }}</span>
          </div>
          <div>
            流程状态：
            <span>{{ flow.status_name }}</span>
          </div>
          <div>
            任务负责人：
            <span>{{ flow.inspector_name ? flow.inspector_name : '无' }}</span>
          </div>
        </div>

        <el-steps
          direction="vertical"
          :active="flow.status == 2 ? 50 : flow.current_step"
          finish-status="success"
        >
          <el-step title="" v-for="item in flow.tasks" :key="item.id">
            <template slot="description">
              <div class="step-content">
                <div class="step-item" v-for="task in item" :key="task.id">
                  <p class="node-name">
                    {{ task.name }}
                    <span :class="task.status_class"
                      >{{ task.user_name }} {{ task.status_name }}</span
                    >
                  </p>
                  <p
                    class="done-time"
                    v-if="task.status == 3 || task.status == 100"
                  >
                    {{ task.start_time }} ~ {{ task.done_time }}
                  </p>

                  <div>
                    <div
                      class="node-body m-t-20"
                      v-if="task.fields && task.fields.length > 0"
                    >
                      <div class="feedback-title bold">反馈</div>
                      <div class="feedback-wrap">
                        <div
                          class="feedback-item"
                          v-for="f in task.fields"
                          v-if="f.value"
                          :key="f.key"
                        >
                          <p class="item-key">{{ f.key }}</p>
                          <div class="feedback-imgs" v-if="f.type == 1">
                            <template v-for="img in f.value">
                              <el-image
                                style="
                                  width: 100px;
                                  height: 100px;
                                  margin-right: 6px;
                                "
                                :src="img"
                                fit="cover"
                                :preview-src-list="f.value"
                              >
                              </el-image>
                            </template>
                            <!-- <img v-for="img in f.value" :src="img" /> -->
                          </div>
                          <p class="text-info" v-else>{{ f.value }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-step>
        </el-steps>
      </div>
    </div>
  </div>
</template>

<script>
import { productShow } from '@/service/getData'
import { groupBy } from '@/utils/index'

const taskStatusInfo = {
  0: {
    text: '待分配',
    className: 'label-default',
  },
  1: {
    text: '待开始',
    className: 'label-primary',
  },
  2: {
    text: '进行中',
    className: 'label-info',
  },
  3: {
    text: '待检验',
    className: 'label-pink',
  },
  4: {
    text: '验收未通过',
    className: 'label-warning',
  },
  100: {
    text: '已完成',
    className: 'label-success',
  },
}

const flowStatusTextMap = {
  0: {
    text: '待开始',
    className: 'label-primary',
  },
  1: {
    text: '进行中',
    className: 'label-info',
  },
  2: {
    text: '已完成',
    className: 'label-success',
  },
  3: {
    text: '已关闭',
    className: 'label-warning',
  },
  4: {
    text: '已暂停',
    className: 'label-pink',
  },
}

export default {
  data() {
    return {
      product: {},
      flow: {},
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      let res = await productShow({ id: this.$route.params.id })
      this.product = res.data.product
      if (this.product.status != 0 && res.data.flow.id > 0) {
        this.flow = this.taskSortByStep(res.data.flow)
      }
    },

    taskSortByStep(res) {
      res.status_name = flowStatusTextMap[res.status].text
      res.tasks.map((item) => {
        item.show_status = true
        item.status_name = taskStatusInfo[item.status].text
        item.status_class = taskStatusInfo[item.status].className

        item.start_time = this.$time(item.start_time).format('YYYY-MM-DD HH:mm')
        item.done_time = this.$time(item.done_time).format('YYYY-MM-DD HH:mm')
        if (item.user_ids) {
          if (item.status == 0) {
            item.status_name = '待领取'
          }
          item.user_ids = JSON.parse(item.user_ids) || []
        } else {
          item.user_ids = []
        }
        if (item.field_value_id > 0 && item.field_value.value.length > 0) {
          let fields = JSON.parse(item.field_value.value)
          item.fields = fields.map((item) => {
            let field = {
              key: item.key,
              type: item.type == 8 ? 1 : 0,
              value: this.displayFieldValue(item),
            }
            return field
          })
        }

        // if (item.inspect_logs.length > 0) {
        //   let prev = item.step - 1
        //   item.inspect_logs.map(log => {
        //     log.step = prev
        //     log.created_at = formatTime(new Date(log.created_at))
        //   })
        //   let logs = this.data.logs
        //   if (!logs[prev]) {
        //     logs[prev] = []
        //   }
        //   logs[prev] = logs[prev].concat(item.inspect_logs)
        //   this.setData({
        //     logs: logs
        //   })
        // }

        if (
          (res.status == 0 || res.status == 3 || res.status == 4) &&
          item.status != 100
        ) {
          item.show_status = false
        }
      })

      res.tasks.sort(function (a, b) {
        return a.step - b.step
      })

      let tasks = groupBy(res.tasks, function (item) {
        return [item.step]
      })
      res.tasks = tasks
      return res
    },
    displayFieldValue(field) {
      if (!field.value) return ''
      if (field.type == 8) {
        let imgs = field.value.split(',')
        return imgs
      } else if (field.type == 7) {
        let dates = field.value.split(',')
        return dates.join('至')
      } else {
        return field.value
      }
    },
  },
}
</script>

<style scoped>
.step-content {
  display: flex;
  flex-direction: column;
  /* flex-wrap: wrap; */
  padding-top: 2px;
  color: #333333;
}
.node-name {
  border-left: 4px solid #25476a;
  padding-left: 4px;
  line-height: 16px;
  margin-bottom: 4px;
  font-size: 14px;
}
.node-name span {
  display: inline;
  padding: 2px 4px;
  font-size: 75%;
  font-weight: 700;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25em;
  background-color: #25476a;
  position: relative;
  top: -1px;
  margin-left: 4px;
}
span.label-success {
  background-color: #8bc34a;
}
.step-item {
  margin-right: 20px;
  border-bottom: 1px dotted #cccccc;
  margin-bottom: 20px;
  padding-bottom: 10px;
}
.feedback-wrap {
  border: 1px solid #eee;
  padding: 0 10px;
  background: #fafafa;
  border-radius: 4px;
  /* margin-top: 10px; */
}

.feedback-item {
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  /* justify-content: space-between; */
  /* align-items: center; */
}

.feedback-imgs img {
  width: 60px;
  height: 60px;
  margin-right: 10px;
}
.node-body {
  padding-bottom: 10px;
  margin-top: 10px;
}
.done-time {
  margin-bottom: 0;
}
.item-key {
  margin-bottom: 0;
}
.flow-info {
  margin-bottom: 30px;
}
</style>